import { useRef as g, useMemo as p, useEffect as I } from "react";
function C(s) {
  let r = !1, t;
  return (...o) => (r || (r = !0, t = s(...o)), t);
}
const m = (s) => Array.isArray(s) && s.every(
  (r) => Array.isArray(r) && r.length === 2 && typeof r[1] == "function"
), M = (s, { ifDefined: r, ifTrue: t, ifFalse: o, ifOfType: c } = {}) => {
  const y = g(), A = g(!1), e = p(
    () => Array.isArray(r) && r.length > 0 || Array.isArray(t) && t.length > 0 || Array.isArray(o) && o.length > 0 || m(c),
    [r, t, o, c]
  ), l = p(() => {
    if (m(c))
      return c.map((u) => u[0]).flat();
  }, [c]);
  I(
    () => {
      var u, a, h;
      if (!((u = r == null ? void 0 : r.some) != null && u.call(r, (n) => typeof n > "u") || (a = t == null ? void 0 : t.some) != null && a.call(t, (n) => n === !1) || (h = o == null ? void 0 : o.some) != null && h.call(o, (n) => n === !0) || m(c) && c.some(([n, E]) => !E(n))))
        return A.current || (y.current = s(), A.current = !0), () => {
          A.current && typeof y.current == "function" && y.current();
        };
    },
    e ? [
      ...r ?? [],
      ...t ?? [],
      ...o ?? [],
      ...l ?? []
    ] : void 0
  );
};
export {
  C as once,
  M as useEffectOnce
};
